<template>
  <div :class="['pop-container', {open: !!postDetail.ig_id}]">
    <div class="pop-box" :data-popmappostid="postDetail.ig_id">
      <div class="btn-close"><img @click="$emit('close')" :src="getSource('project/close.svg')" /></div>
      <div class="pop-content" v-if="postDetail && postDetail.ig_id">
        <swiper v-if="transformedAlbum.length > 1" :options="swiperOption" ref="mySwiper" class="mySwiper">
          <swiper-slide v-for='(item, key) in transformedAlbum' :key="key">
            <img class="preview swiper" :src="item" />
          </swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"><img :src="getSource('project/previous.svg')" /></div>
          <div class="swiper-button-next" slot="button-next"><img :src="getSource('project/next.svg')" /></div>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="album-icon"><img :src="getSource('project/album.svg')" /></div>
        </swiper>
        <img v-if="!postDetail.is_video && transformedAlbum.length <= 1" class="preview" :src="transformedAlbum[0]" />
        <video v-if="postDetail.is_video" class="preview" muted autoplay playsinline controls>
          <source :src="postDetail.video" type="video/mp4">
          <source :src="postDetail.video" type="video/ogg">
        </video>

        <div class="text-content">
          <div class="user" v-html="postDetail.owner" />
          <div class="text" v-if="postDetail.caption" v-html="postDetail.caption" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import $ from 'jquery'

export default {
  props: ['postDetail'],
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    transformedAlbum () {
      return this.postDetail.album.split('\n')
    }
  },
  data () {
    return {
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
        lazy: true,
        spaceBetween: 0,
        keyboard: true
      },
      mySwiper: {}
    }
  },
  watch: {
    'postDetail.ig_id': function (newVal, oldVal) {
      const self = this
      if (!newVal) {
        document.body.style['overflow-y'] = 'auto'
        return
      } else {
        document.body.style['overflow-y'] = 'hidden'
        setTimeout(() => {
          self.mySwiper = self.$refs.mySwiper ? self.$refs.mySwiper.swiper : self.mySwiper
          // resize text-container container based on image width so that there is no extra space
          var img = self.$el.querySelector('img.preview')

          const onloadFunc = () => {
            setTimeout(() => {
              self.$el.querySelector('.text-content').style.width = img.width + 'px'
              self.$el.querySelector('.pop-content').style.width = img.width + 'px'
              if (self.$refs.mySwiper) {
                self.$el.querySelector('.mySwiper').style.width = img.width + 'px'
                self.mySwiper.update()
              }
            })
          }

          if (img) {
            img.onload = function () {
              onloadFunc()
            }

            if (img.complete) {
              onloadFunc()
            }
          }
        })
      }
    }
  },
  methods: {
    getSource (value) {
      if (!value) return null
      return require(`images/${value}`)
    }
  },
  mounted () {
    const self = this
    $(document).click(function (event) {
      // close pop-up if clicked outside
      const target = $(event.target)
      if (!target.closest('.pop-box').length &&
      $('.pop-box')[0].offsetWidth > 0) {
        self.$emit('close')
      }
    })
  }
}
</script>
<style lang="scss">
.pop-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  background-color: rgba(0,0,0,.5);
  opacity: 0;
  z-index: 1;
  transition: opacity 0.5s ease-in-out;
  &.open {
    opacity: 1;
    width: 100vw;
    height: 100vh;
  }
}
.pop-box {
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #FFF;
  height: 100%;
  max-height: 90%;
  overflow: hidden;
  @media (min-height: 750px) {
    max-height: 750px;
  }
  .btn-close {
    text-align: right;
    img {
      cursor: pointer;
      border-radius: 50%;
      margin: 10px 3% 0 0;
      opacity: 0.7;
      transition: opacity .15s ease-out;
      width: 25px;
      &:hover {
        opacity: 1;
      }
    }
  }
  .pop-content {
    overflow-y: auto;
    overflow-x: hidden;
    width: 94vw;
    height: 88%;
    @media (max-height: 400px) {
      height: 85%;
    }
    @include breakpoint($d_small) {
      width: 100%;
      max-width: 900px;
    }
    img.preview {
      width: 100%;
      @include breakpoint($d_small) {
        width: unset;
        min-width: 310px;
        max-width: 100%;
        min-height: 250px;
        max-height: 510px;
        &.swiper {
          max-width: 100%;
        }
      }
      @media (max-height: $d_small) {
        max-height: 70vh;
      }
    }
    video.preview {
      width: 100%;
      max-height: 510px;
      @media (max-height: $d_small) {
        height: 70vh;
      }
    }
    .album-icon {
      position: absolute;
      top: 10px;
      right: 10px;
      font-weight: bold;
      color: #FFF;
      z-index: 1;
      width: 25px;
    }
    .album-nav {
      .dots {
        &.active {
          font-weight: bold;
          font-size: 1.1em;
        }
      }
    }
    .text-content {
      text-align: left;
      padding: 0 3%;
      margin: 0 auto;
      max-width: 90%;
      .user {
        font-family: $font-CuratorBold;
        font-size: 16px;
        color: #333;
        padding: 10px 0;
      }
      .text {
        font-size: 16px;
        color: #333;
        font-family: $font-CuratorRegular;
        word-break: break-word;
      }
    }
  }
  .swiper-button-prev, .swiper-button-next {
    display: none;
    background-image: unset;
    outline: none;
    @include breakpoint($d_medium) {
      display: block;
    }
  }
  .swiper-pagination-bullets {
    bottom: 20px;
    .swiper-pagination-bullet {
      background: #c1cac9;
      opacity: 0.8;
      &.swiper-pagination-bullet-active {
        background: $stlightblue;
      }
    }
  }
}
</style>
